import React, { Component  } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import Modal from 'react-awesome-modal';

import {
    Container,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Button,
    Input,
    UncontrolledTooltip,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    CardTitle,
    CardText,
    Table,
    Progress,
    FormGroup,
    Label,
    Tooltip
} from 'reactstrap';

import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutMaster from "../../../views/layout/Master";
import {layout} from "../../../../ts-helpers/decorators";
import swal from "sweetalert2";
import {Redirect} from "react-router";
import validate from "../../../services/ValidationService";
import Loading from "../../includes/Loading";
import {AUTH_LOGIN} from "../../../store/actions";

@layout(LayoutMaster)
class ResetPassword extends Component<any> {
    animating = false;

    state = {
        errors: [],
        loading: false,
        submitted:false,
        passwordConfirm: {
            value: "",
            valid: false,
            touched: false,
        },
        password: {
            value: "",
            valid: false,
            touched: false,
        },
        newErrPassConfirm:'',
        newErrPass:'',
        newErrVerify:'',
        ee:false,
        updated:false,
        userMessage : false,
        v_message : '',
    };

    componentDidMount() {

    }

    @autobind
    validatePassword(event) {
        const { password, passwordConfirm, ee } = this.state;
        password.value = event.target.value;
        password.valid = validate.password(event.target.value);
        password.touched = true;

        if(password.value === passwordConfirm.value){
            var aaa = true;
        }else{
            var aaa = false;
        }

        this.setState({
            password,
            newErrPass:'',
            ee:aaa
        });
    }

    @autobind
    validatePasswordConfirm(event) {
        const { password, passwordConfirm, ee } = this.state;
        passwordConfirm.value = event.target.value;
        passwordConfirm.valid = validate.password(event.target.value);
        passwordConfirm.touched = true;

        if(password.value === passwordConfirm.value){
            var aaa = true;
        }else{
            var aaa = false;
        }

        this.setState({
            passwordConfirm,
            newErrPassConfirm:'',
            ee:aaa
        });
    }

    @autobind
    formSubmitReset(event) {
        event.preventDefault();
        const { forgot_token } = this.props.match.params;
        this.setState({ submitted: true });
        this.setState({ loading: true });

        const { password, passwordConfirm } = this.state;
        if (!password.valid || !passwordConfirm.valid) {
            return;
        }

        http.post('/users/reset-password', {
            password: password.value,
            forgot_token: forgot_token,
        }).then((response: any) => {
            if (response.ok) {
                response.json().then((data: any) => {
                    //alert(data.message)
                    this.setState({
                        updated: false,
                        userMessage : true,
                        v_message:data.message
                    });
                });
            } else {
                response.json().then((jsonData: any) => {
                    this.setState({
                        errors: jsonData.errors,
                        updated: false,
                        userMessage : false,
                    });
                });
            }
        })
            .catch((err) => {
                console.log(err);
            });
    }

    @autobind
    openModalVregister() {
        this.setState({
            userMessage : true,
            updated : false,
        });
    }

    @autobind
    closeModalVregister() {
        this.setState({
            userMessage : false,
            updated : true,
        });
    }

    render() {
        const { errors, password, passwordConfirm, loading, submitted, newErrPass, newErrPassConfirm, userMessage, v_message, updated, ee } = this.state;
        if (updated) {
            return <Redirect to={Route.toUrl("home")} />
        }

        return (
            <Container className="block_forgot_password_page">
                <Row>
                    <Col className="col-sm-4 col-sm-offset-4 form_block_forgot_pass">
                        <div className='forgot_title'>Forgot password</div>
                        <form onSubmit={this.formSubmitReset}>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Password"
                                    onChange={this.validatePassword}
                                    value={password.value}
                                />
                                <div className='reg_errors_style'>
                                    {validate.showError(password, "Invalid password: min 6 letter, at least one digit.")}
                                    {validate.showDbError(errors, "password")}
                                    {newErrPass}
                                </div>
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confirm password"
                                    onChange={this.validatePasswordConfirm}
                                    value={passwordConfirm.value}
                                />
                                <div className='reg_errors_style'>
                                    {validate.showError(passwordConfirm, "Invalid password: min 6 letter, at least one digit.")}
                                    {validate.showDbError(errors, "password")}
                                    {newErrPassConfirm}
                                </div>
                            </div>

                            {
                                password.value.length >=6 && passwordConfirm.value.length >=6 && ee == false  &&
                                <div className='reg_errors_style_forgot'>
                                    Passwords does not match
                                </div>
                            }

                            <Button className="my_sign_in_submit" disabled={!password.valid || !passwordConfirm.valid || ee == false} >
                                {submitted && loading ? <Loading isLoading={loading} icon="auth" /> : "Accept"}
                            </Button>
                        </form>

                        {
                            userMessage == true &&
                                <Modal
                                    visible={this.state.userMessage}
                                    width="500"
                                    effect="fadeInDown"
                                    onClickAway={() => this.closeModalVregister()}
                                >
                                    <Container>
                                        <Row className="coll_popup_header">
                                            <Col xs={12} className="text-center coll_title">
                                                {v_message}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} className="link_styless_popup">
                                                <Button className='userMessage_form_links' onClick={() => this.closeModalVregister()}>Ok</Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Modal>
                        }

                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ResetPassword;
